<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue'

const props = defineProps(['schemas'])

const scriptElement = ref(null)

const unifiedSchema = computed(() => {
    // Filter out falsy values and remove any nested @context properties
    // since we define @context at the root level
    const cleanedSchemas = props.schemas
        .filter(Boolean)
        .map(schema => {
            if (schema && typeof schema === 'object') {
                const { '@context': _, ...rest } = schema
                return rest
            }
            return schema
        })

    return {
        "@context": "https://schema.org",
        "@graph": cleanedSchemas
    }
})

onMounted(() => {
    scriptElement.value = document.createElement('script')
    scriptElement.value.type = 'application/ld+json'
    scriptElement.value.textContent = JSON.stringify(unifiedSchema.value)
    document.head.appendChild(scriptElement.value)
})

onUnmounted(() => {
    if (scriptElement.value && scriptElement.value.parentNode) {
        scriptElement.value.parentNode.removeChild(scriptElement.value)
    }
})
</script>

<template>
    <div style="display: none;"></div>
</template>
